export default __webpack_public_path__ + "static/sidebar-b53f482dd8b027abcdadcc91f1875783.png";